import React from 'react';
import "./sidebar.css";
import { NavLink, useNavigate } from 'react-router-dom';

const Sidebar = (props) => {
    const navigate = useNavigate();

    const sidebarItems = [
        { path: "/Dashboard", icon: "assets/Dashboard.svg", name: "Dashboard" },
        { path: "/Received_orders", icon: "assets/cart1.svg", name: "Received Orders" },
        { path: "/order_management", icon: "assets/order-cart.svg", name: "Order Management" },
        { path: "/Users", icon: "assets/Group.svg", name: "User Management" },
        { path: "/product_management", icon: "assets/productmgmt.svg", name: "Product Management" },
        { path: "/coupon_management", icon: "assets/Couponmgmt.svg", name: "Coupon Management" },
        { path: "/Analytics", icon: "assets/Analyst.svg", name: "Analytics" },
        { path: "/warranty_registration", icon: "https://colorbots3.s3.ap-south-1.amazonaws.com/warrantyreg.svg", name: "Warranty Register" },
        { path: "/claim-free", icon: "assets/free-coupon.svg", name: "Claim Free" },
        { path: "/warranty_claim", icon: "assets/claim 1.svg", name: "Warranty Claim" }

    ];

    return (
        <div>
            <nav id="sidebar" className={props.active ? "active" : ""}>
                <div className={props.active ? "sidebar-headeractive" : "sidebar-header"}>
                    {props.active ? (
                        <NavLink to="/Dashboard" className={({ isActive }) => isActive ? "active" : ""}>
                            <img src="assets/closelogo.png" alt="Close" width="50px" className="active" />
                        </NavLink>
                    ) : (
                        <NavLink to="/Dashboard">
                            <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/Home-Page/Colorbot-logo-tm.png" alt="Logo" width="120px" />
                        </NavLink>
                    )}
                </div>

                <ul className="list-unstyled side-link">
                    {sidebarItems.map((item, index) => (
                        <li key={index}>
                            {item.path ? (
                                <NavLink
                                    to={item.path}
                                    className={({ isActive }) => isActive ? "active" : ""}
                                    title={item.name}
                                >
                                    <div className="link-content">
                                        <img src={item.icon} alt="" width="25" height="25" />
                                        {!props.active && <span >{item.name}</span>}
                                        {props.active && <span className="tooltip">{item.name}</span>}
                                    </div>
                                </NavLink>
                            ) : (
                                <div title={item.name} className="link-content">
                                    <img src={item.icon} alt="" width="25" height="25" />
                                     {!props.active && <span >{item.name}</span>}
                                    {props.active && <span className="tooltip">{item.name}</span>}
                                </div>
                            )}
                        </li>
                    ))}
                </ul>

                <hr />

                <div className="w-100 text-center" style={{ cursor: "pointer" }} onClick={() => props.setModalShow1(true)}>
                    {props.active ? (
                        <i className='fa fa-sign-out' title="Sign Out" />
                    ) : (
                        <img
                            src="assets/button.svg"
                            alt="Sign Out"
                            style={{ cursor: "pointer" }}
                            title="Sign Out"
                        />
                    )}
                </div>
            </nav>
        </div>
    );
};

export default Sidebar;
